import { FinanceSearchField } from '@common/enums/financeSearchField';
import { normalizeSearchText } from '@common/utils/normalizeSearchText';
import { searchTextMatchesProcessId } from '@common/utils/searchTextMatchesProcessId';
import { formatDateIntoString } from '@frontend/utils/formatDateIntoString';
import type { FinancingSearchInputFilters } from './financingSearchInputFilters';

export type FinancingInputFilters = Omit<FinancingSearchInputFilters, 'endDate' | 'searchField' | 'startDate'> & {
    endDate?: string;
    groupName?: string;
    organizationName?: string;
    processId?: string;
    relationNumber?: string;
    requesterPractitionerUid?: string;
    startDate?: string;
};

export function getFilters({
    endDate,
    searchField,
    searchText,
    startDate,
    ...restFilters
}: FinancingSearchInputFilters) {
    const newFilters: FinancingInputFilters = {
        ...restFilters,
        endDate: formatDateIntoString(endDate) ?? undefined,
        startDate: formatDateIntoString(startDate) ?? undefined,
    };

    if (searchText) {
        const trimmedSearchText = normalizeSearchText(searchText);
        switch (searchField) {
            case FinanceSearchField.processNumber:
                if (searchTextMatchesProcessId(trimmedSearchText)) {
                    newFilters.processId = trimmedSearchText;
                }
                break;
            case FinanceSearchField.groupName:
            case FinanceSearchField.organizationName:
            case FinanceSearchField.relationNumber:
            case FinanceSearchField.requesterPractitionerUid:
                newFilters[searchField] = trimmedSearchText;
                break;
            default:
                newFilters.searchText = trimmedSearchText;
                break;
        }
    }

    return newFilters;
}
